<button type="button" class="btn" [ngClass]="classes" [disabled]="disabled">
  <ng-content></ng-content>
  <fa-icon [icon]="faCircleNotch" [spin]="true" *ngIf="loading" class="btn-loader"></fa-icon>
</button>
